import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      user: {
        id: localStorage.getItem("alalmiyaae_Dash_User_Id"),
        token: localStorage.getItem("alalmiyaae_Dash_Token"),
        usertype: localStorage.getItem("alalmiyaae_Dash_User_Type"),
        name: localStorage.getItem("alalmiyaae_Dash_User_name"),
        image: localStorage.getItem("alalmiyaae_Dash_userImg"),
        phone: localStorage.getItem("alalmiyaae_Dash_userPhone"),
        permissions: localStorage.getItem("alalmiyaae_Dash_permissions"),
      },
    };
  },
  mutations,
  actions,
  getters,
};
